import { Children, isValidElement, ReactNode } from "react";
import { EmptyArray } from "../../../utilities";
import { Actions } from "../ListActions";
import { DataListActionProps } from "../ListAction";

/**
 * Gets the actions from the specified children.
 * @param children The children to get the actions from.
 * @returns The array of actions.
 */
export function getActions(children: ReactNode | undefined): ReadonlyArray<DataListActionProps> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== Actions.Action) {
        // Actions ignoring unsupported child component.
        return null;
      }
      return child.props;
    })?.filter((tab) => !!tab) ?? EmptyArray
  );
}
